import { render, staticRenderFns } from "./v-email-chip.vue?vue&type=template&id=65c38480"
import script from "./v-email-chip.vue?vue&type=script&lang=js"
export * from "./v-email-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports